import React from 'react'
import { graphql, withApollo } from 'react-apollo'

import productQuery from '~/App/graphql/queries/product.gql'
import { Modal, Tag, Select, InputNumber, Form, Tooltip, Icon, message, Radio } from 'antd'
import { inject, observer } from 'mobx-react'
// import renderQuestionInput from '~/renderQuestionInput'
// import registrationQuery from '~/App/graphql/queries/registration.gql'
import orderRegistrationFragment from '~/App/graphql/fragments/orderRegistration.gql'
import renderQuestionInput from '~/renderQuestionInput'
import withProps from 'recompose/withProps'
import _get from 'lodash/get'
import { FormattedNumber, injectIntl, FormattedMessage } from 'react-intl'
import { stringify as qsStringify } from 'tiny-querystring'
import localeGet from '~/App/utils/localeGet'
import './styles.css'
/*
{
  productId,

}

*/
// const optionFieldMap = {
//   Open: 'value',
//   Choice: 'itemId',
//   MultiChoice: 'itemIds'
// }
const inputCols = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}
@Form.create()
@withApollo
@withProps(({ client, registrationId }) => {
  const registration = client.readFragment({
    id: `Registration:${registrationId}`,
    fragment: orderRegistrationFragment
  })
  return {
    registration
  }
})
@graphql(productQuery, {
  options: ({ productId }) => ({
    variables: ({
      _id: productId
    })
  })
})
@injectIntl
@inject('i18n')
@inject('router')
@observer
class OrderItemModal extends React.Component {
  onOk = () => {
    const { form, onAddOrderItem, data, registration } = this.props
    const { product } = data
    const { orderItems = [] } = registration
    form.validateFields((err, orderItem) => {
      if (err) {
        return console.error(err)
      }
      const productMaxItems = _get(product, 'maxItemsPerRegistration', 0)
      const selectedItems = orderItems.filter(item => item.productId === product._id).reduce((sum, item) => sum + item.quantity, 0)
      const maxItems = productMaxItems - selectedItems
      if (maxItems < 0) {
        return message.error(`only ${productMaxItems} item(s) allowed`)
      }

      onAddOrderItem(orderItem)
    })
  }

  onCancel = () => {
    const { location, history } = this.props.router
    const { pdId, ...query } = location.query
    if (this.props.masterType === 'Order') {
      history.replace({
        ...location,
        search: `?${qsStringify(query)}`
      })
      location.query = query
    } else {
      history.replace({
        ...location,
        search: `?${qsStringify({
          ...query,
          pdId: 'select'
        })}`
      })
    }
  }

  get questionInput () {
    const { form, data, i18n, intl, event } = this.props
    const { getFieldDecorator, getFieldValue, resetFields, setFieldsValue } = form
    const { product } = data
    const { locale } = i18n
    const questions = _get(product, 'questions', [])
    const shirtTypes = _get(event, 'shirtTypes', [])
    const shirtCounts = _get(event, 'shirtCounts', [])
    const requiredFieldMessage = intl.formatMessage({
      id: 'app.requiredFieldMessage',
      defaultMessage: 'This field is required'
    })
    return <React.Fragment>
      {questions.map((question, questionIndex) => {
        getFieldDecorator(`options[${questionIndex}].questionId`, {
          initialValue: question._id
        })
        if (_get(question, 'inputType') === 'shirtTypes') {
          const shirtTypeIds = _get(question, `shirtTypeIds`, []) || []
          const availableShirtTypes = shirtTypes.filter(type => shirtTypeIds.length === 0 || shirtTypeIds.includes(type._id))
          let shirtTypeId = _get(product, `options[${questionIndex}].shirtTypeId`)
          if (!shirtTypeId) {
            shirtTypeId = availableShirtTypes.length === 1 ? _get(availableShirtTypes, [0, '_id']) : getFieldValue(`options[${questionIndex}].shirtTypeId`)
          }
          shirtTypeId = getFieldValue(`options[${questionIndex}].shirtTypeId`) || shirtTypeId
          const shirtType = availableShirtTypes.find(type => type._id === shirtTypeId)
          const shirtIds = _get(question, `shirtIds`, []) || []
          return (<div>
            <Form.Item
              label={
                <span>
                  {localeGet(question, 'name', locale)}
                  {question.infoMessage &&
                    <Tooltip title={localeGet(question, 'infoMessage', locale)} placement="rightBottom">
                      &nbsp;<Icon type="question-circle-o" style={{ fontSize: 'large' }} />
                    </Tooltip>
                  }
                </span>
              }
              {...inputCols}
              extra={localeGet(question, 'extraMessage', locale)}
              key={questionIndex}
            >
              {getFieldDecorator(
                `options[${questionIndex}].shirtTypeId`,
                {
                  initialValue: shirtTypeId,
                  rules: [{
                    required: true,
                    message: requiredFieldMessage
                  }]
                }
              )(<Radio.Group onChange={() => resetFields([`options[${questionIndex}].shirtId`]) || setFieldsValue({
                [`options[${questionIndex}].shirtId`]: null
              })} >
                {availableShirtTypes.map(type =>
                  <Radio key={type._id} value={type._id} >
                    {localeGet(type, 'name', locale)}
                  </Radio>
                )}
              </Radio.Group>)}
              {(shirtType && shirtType.imageUrl) &&
                <img src={shirtType.imageUrl} alt="shirt type" style={{ maxWidth: '100%' }} />
              }
            </Form.Item>
            {shirtTypeId && <Form.Item
              label={<FormattedMessage id="app.shirtSize" defaultMessage="Shirt Size" />}
              {...inputCols}
              ref={ref => { this.modalRef = ref }}
            >
              {getFieldDecorator(`options[${questionIndex}].shirtId`, {
                initialValue: _get(product, `options[${questionIndex}].shirtId`),
                rules: [{
                  required: true,
                  message: requiredFieldMessage
                }]
              })(
                <Select getPopupContainer={() => this.modalRef} >
                  {/* {console.log({shirtCounts, shirtTypeId, shirtIds})} */}
                  {shirtCounts.filter(s => s.shirtTypeId === shirtTypeId && (shirtIds.length === 0 || shirtIds.includes(s._id))).map(shirt =>
                    <Select.Option key={shirt._id} value={shirt._id} disabled={shirt.quantity && shirt.count >= shirt.quantity}>
                      {localeGet(shirt, 'name', locale)}
                    </Select.Option>
                  )}
                </Select>
              )}
            </Form.Item>}
          </div>)
        } else {
          const optionField = {
            Open: 'value',
            Choice: 'itemId',
            MultiChoice: 'itemIds'
          }[question.kind]
          const optionDecorator = getFieldDecorator(`options[${questionIndex}].${optionField}`, {
            rules: [{ required: question.required, message: `${localeGet(question, 'name', locale)} is Required` }]
          })
          return <Form.Item
            label={
              <span>
                {localeGet(question, 'name', locale)}
                {question.infoMessage &&
                <Tooltip title={localeGet(question, 'infoMessage', locale)} placement="rightBottom">
                  &nbsp;<Icon type="question-circle-o" style={{ fontSize: 'large' }} />
                </Tooltip>
                }
              </span>
            }
            {...inputCols}
            key={question._id}
          >
            {optionDecorator(renderQuestionInput({ question, locale }, () => this.modalRef))}
          </Form.Item>
        }
    })}
    </React.Fragment>
  }

  render () {
    const { masterId, masterType, registrationId, registration, data, i18n: { locale }, form } = this.props
    const { participants, orderItems = [] } = registration
    const { getFieldDecorator, getFieldValue } = form
    if (data.loading) {
      return <div>Loading</div>
    }
    if (data.error) {
      return <div>Error</div>
    }
    const { product } = data
    getFieldDecorator(`productId`, {
      initialValue: product._id
    })
    getFieldDecorator(`eventId`, {
      initialValue: product.eventId
    })
    getFieldDecorator(`masterId`, {
      initialValue: masterId
    })
    getFieldDecorator(`registrationId`, {
      initialValue: registrationId
    })
    getFieldDecorator(`masterType`, {
      initialValue: masterType
    })
    const quantityDecorator = getFieldDecorator('quantity', {
      initialValue: 1,
      rules: [{
        required: true
      }]
    })
    const participantDecorator = getFieldDecorator('participantId', {
      initialValue: participants.length === 1 ? _get(participants, [0, '_id']) : undefined,
      rules: [{
        required: true
      }]
    })
    const productMaxItems = _get(product, 'maxItemsPerRegistration', 0)
    const selectedItems = orderItems.filter(item => item.productId === product._id).reduce((sum, item) => sum + item.quantity, 0)
    const maxItems = productMaxItems - selectedItems

    const quantity = getFieldValue('quantity')
    return <Modal
      visible
      onOk={this.onOk}
      onCancel={this.onCancel}
      title={<span><Tag color="blue">{<FormattedNumber value={product.price} />} THB</Tag> {localeGet(product, 'name', locale)}</span>}
    >
      <div ref={ref => { this.modalRef = ref }} >
        <Form className="orderItemForm" >
          {product.imageUrl && <div style={{ textAlign: 'center' }}><img src={product.imageUrl} alt={product.name.en} style={{ maxWidth: '80%', maxHeight: '50vh', margin: '0 auto 12px' }}/></div>}
          <Form.Item label={{ en: 'Quantity', zh: 'Quantity', th: 'จำนวน' }[locale]} {...inputCols}>
            {quantityDecorator(
              <InputNumber min={_get(product, 'minItems', 1)} {...(productMaxItems > 0 && { max: maxItems })} />
            )}
          </Form.Item>
          {product.deliveryOption === 'none' &&
            <Form.Item label={{ en: 'Participants pick up with Race Kit', zh: 'Participants pick up with Race Kit', th: 'ผู้สมัครที่จะรับใน Race Kit' }[locale]} {...inputCols}>
              {participantDecorator(
                <Select>
                  {participants.map(participant =>
                    <Select.Option key={participant._id}>
                      {_get(participant, 'profile.firstName')} {_get(participant, 'profile.lastName')}
                    </Select.Option>
                  )}
                </Select>
              )}
            </Form.Item>
          }
          <Form.Item label={{ en: 'Amount', zh: 'Amount', th: 'ยอดเงิน' }[locale]} {...inputCols}>
            {<FormattedNumber value={product.price * quantity} />} THB
          </Form.Item>
          {this.questionInput}
        </Form>
      </div>
    </Modal>
  }
}

export default OrderItemModal



// WEBPACK FOOTER //
// ./src/App/components/OrderItemModal/OrderItemModal.js